module.exports = __webpack_public_path__ + "img/logo.1b6eb239.svg";